/* eslint-disable import/no-default-export */
import { getPoint, getAngle } from '@/utils/utils'

// 检查scroll是否触顶
const checkScrollStartPan = function (el, evt, panType) {
  const res = {}
  if (panType === 'vertical') {
    const scrollTop = el.scrollTop
    if (scrollTop <= 0) {
      res.SCROLL_TOP = true
    }
    if (scrollTop + el.offsetHeight >= el.scrollHeight - 1) {
      res.SCROLL_BOTTOM = true
    }

    return Object.keys(res).length ? res : null
  }
  if (panType === 'horizontal') {
  }
}

// 长滑动，只能4个方向，一旦触发某个维度（水平，垂直）长滑动，将一直保持此状态直到放开
const bindDirective = function (el, binding, vnode) {
  el.isClosePan = binding.value.isClosePan || false // isClosePan表示是否需要关闭pan模式
  let startState
  let currentState
  let currentPanType = '' // 开始按照horizontal或者vertical滑动模式，直到放开为止
  let scrollStatus = null
  const targetPanType = binding.arg || 'all'
  const canScroll = binding.modifiers.scroll
  const cbData =
    typeof binding.value === 'function'
      ? {
          methods: binding.value
        }
      : binding.value

  // 重置
  const reset = () => {
    startState = null
    currentState = null
    currentPanType = ''
    scrollStatus = null
  }

  // 起始点设置
  const init = evt => {
    startState = {
      time: new Date().getTime(),
      point: getPoint(evt)
    }
    currentPanType = ''
    currentState = {
      time: startState.time,
      point: startState.point,
      state: 'START'
    }
  }

  // scroll拖拽模式禁用滚动，返回拖拽方向
  const dragDirPrevent = (evt, delta, inPanMode) => {
    if (canScroll && scrollStatus) {
      // 构成拖拽时 禁用微信滑动
      if (scrollStatus.SCROLL_TOP && delta.totalY > 0) {
        if (currentState.state === 'MOVING') {
          evt.cancelable && evt.preventDefault()
          evt.stopPropagation()
        }
        return 'DRAG_DOWN'
      }

      if (scrollStatus.SCROLL_BOTTOM && delta.totalY < 0) {
        if (currentState.state === 'MOVING') {
          evt.cancelable && evt.preventDefault()
          evt.stopPropagation()
        }
        return 'DRAG_UP'
      }

      return 'NO_DIR'
    }
  }

  // 统一处理
  const handler = evt => {
    // 尚未开始滑动，起始点更新
    const endPoint = getPoint(evt)
    const startPoint = startState.point
    const angle = getAngle(startPoint, endPoint)
    const currentTime = new Date().getTime()
    const delta = {
      x: endPoint.x - currentState.point.x,
      y: endPoint.y - currentState.point.y,
      totalX: endPoint.x - startPoint.x,
      totalY: endPoint.y - startPoint.y,
      time: currentTime - currentState.time
    }

    Object.assign(currentState, {
      point: endPoint,
      time: currentTime
    })

    // 是否为需要trigger的类型
    const isCorrectPanType =
      targetPanType === 'all' || currentPanType === targetPanType
    // scroll拖拽方向与防滚动处理
    const dragDirection = dragDirPrevent(evt, delta, isCorrectPanType)
    if (isCorrectPanType) {
      const params = {
        event: evt,
        currentState,
        currentPanType,
        delta,
        dragDirection
      }
      cbData.methods(params)
      return
    }

    // 判断是否进入pan
    const speedX = Math.abs(delta.x / delta.time)

    let direction = null
    if (
      Math.abs(angle) < 20 ||
      (currentPanType === 'horizontal' && delta.x >= 0)
    ) {
      direction = 'RIGHT'
    }
    if (
      Math.abs(angle) > 160 ||
      (currentPanType === 'horizontal' && delta.x < 0)
    ) {
      direction = 'LEFT'
    }
    if (
      (angle > 75 && angle < 115) ||
      (currentPanType === 'vertical' && delta.y >= 0)
    ) {
      direction = 'DOWN'
    }
    if (
      (angle < -75 && angle > -115) ||
      (currentPanType === 'vertical' && delta.y < 0)
    ) {
      direction = 'UP'
    }

    // 进入pan模式
    if (!currentPanType && direction && speedX < 0.15) {
      currentPanType = {
        RIGHT: 'horizontal',
        LEFT: 'horizontal',
        UP: 'vertical',
        DOWN: 'vertical'
      }[direction]
      startState.point = endPoint
    }
  }

  el.addEventListener(
    'touchstart',
    function (evt) {
      if (!el.isClosePan) {
        if (el.dataset.panDisable === 'true') {
          return
        }

        if (canScroll) {
          // 如果是能滚动模块儿，等待触顶或者触底后再开始
          scrollStatus = checkScrollStartPan(el, evt, targetPanType)
          if (!scrollStatus) {
            return
          }
        }

        init(evt)
      }
    },
    false
  )
  el.addEventListener(
    'touchmove',
    function (evt) {
      if (!el.isClosePan) {
        binding.modifiers.prevent && evt.cancelable && evt.preventDefault()
        if (!startState) {
          // 如果是能滚动模块儿，等待触顶或者触底后再开始
          if (canScroll) {
            scrollStatus = checkScrollStartPan(el, evt, targetPanType)
            if (scrollStatus) {
              init(evt)
            }
          }
          return
        }
        currentState.state = 'MOVING'
        handler(evt)
      }
    },
    false
  )
  el.addEventListener(
    'touchend',
    function (evt) {
      if (!el.isClosePan) {
        if (!startState) {
          return
        }
        currentState.state = 'END'
        handler(evt)
        reset()
      }
    },
    false
  )
}

const vuePan = {}
vuePan.install = function (Vue) {
  Vue.directive('pan', {
    bind: bindDirective,
    update: function (el, binding, vnode) {
      el.isClosePan = binding.value.isClosePan
    }
  })
}

export default vuePan
